import { render } from "./storageos.vue?vue&type=template&id=77a89e00"
import script from "./storageos.vue?vue&type=script&lang=js"
export * from "./storageos.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../github.com:rancher/dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__